export default function ListingManagement() {
    return(
        <div>
            <p>Listing management</p>
        </div>
    )
}